import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { IconsProviderModule } from 'src/app/icons-provider.module';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzWaterMarkModule } from 'ng-zorro-antd/water-mark';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';

import { HasPermissionDirective, HasAnyPermissionDirective, ValidationErrorDirective } from './directives';
import {
    AbsenceCalendarEventInfoModalComponent,
    AbsenceActionsComponent,
    UpsertAbsenceComponent,
    UpsertAddressComponent,
    UpsertFieldComponent,
    SearchFieldComponent,
    DepartmentSelectComponent,
    UpsertAccountComponent,
    UpsertContactComponent,
    UpsertClientComponent,
    ValidationErrorComponent,
    TrueFalseTableIconComponent,
    FileDownloadLinkComponent,
    WorkTimerComponent,
    ESignComponent,
    ESignFlowSelectComponent,
} from './components';
import { MapComponent } from './components/map/map.component';
import { DraggableUnitDirective } from './directives/draggable-unit.directive';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PrintoutDialogComponent } from './components/printout-dialog/printout-dialog.component';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { EurPipe } from './pipes/eur.pipe';
import { HasDepartmentPermissionDirective } from './directives/has-department-permission.directive';
import { HasAnyDepartmentPermissionDirective } from './directives/has-any-department-permission.directive';
import { HasPermissionInAnyDepartmentDirective } from './directives/has-permission-in-any-department.directive';
import { ClientNameComponent } from './components/client-name/client-name.component';
import { ClientNotificationConfigModalComponent } from './components/client-notification-config-modal/client-notification-config-modal.component';
import { AddressSelectModalComponent } from './components/map/address-select-modal/address-select-modal.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { UpsertDocumentComponent } from './components/upsert-document/upsert-document.component';
import { DocumentFilesTableComponent } from './components/upsert-document/document-files-table/document-files-table.component';
import { DocumentFileSignersModalComponent } from './components/upsert-document/document-files-table/document-file-signers-modal/document-file-signers-modal.component';
import { SearchFieldFormControlComponent } from './components/search-field-form-control/search-field-form-control.component';
import { HeaderMotdMessagesComponent } from './components/header-motd-messages/header-motd-messages.component';
import { MotdMessageModalComponent } from './components/motd-message-modal/motd-message-modal.component';
import { EmployeeNotificationModalComponent } from './components/employee-notification-modal/employee-notification-modal.component';
import { RelatedDocumentsListComponent } from './components/related-documents-list/related-documents-list.component';
import { InfoButtonComponent } from './components/info-button/info-button.component';
import { InfoModalComponent } from './components/info-button/info-modal/info-modal.component';
import { ViewSinvoiceComponent } from './components/view-sinvoice/view-sinvoice.component';
import { UpsertSinvoiceComponent } from './components/upsert-sinvoice/upsert-sinvoice.component';
import { SinvoiceInvoicesTableComponent } from './components/upsert-sinvoice/sinvoice-invoices-table/sinvoice-invoices-table.component';
import { InvoiceSumFieldsComponent } from './components/invoice-sum-fields/invoice-sum-fields.component';
import { HelpMaterialsModalComponent } from './components/help-materials-modal/help-materials-modal.component';
import { SafeYoutubePipe } from './pipes/safe-yt-url.pipe';
import { SafeSharepointUrlPipe } from './pipes/safe-sharepoint-url.pipe';
import { NotificationHistoryButtonComponent } from './components/notification-history-button/notification-history-button.component';
import { NotificationHistoryModalComponent } from './components/notification-history-button/notification-history-modal/notification-history-modal.component';
import { NotificationHistoryEntryDetailsComponent } from './components/notification-history-button/notification-history-modal/notification-history-entry-details/notification-history-entry-details.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ViewDocumentComponent } from './components/view-document/view-document.component';
import { FilePreviewComponent } from './components/file-preview/file-preview.component';
import { FilePreviewModalComponent } from './components/file-preview/file-preview-modal/file-preview-modal.component';
import { FileViewerComponent } from './components/file-preview/file-viewer/file-viewer.component';
import { DocumentFilePreviewComponent } from './components/document-file-preview/document-file-preview.component';
import { DocumentFilePreviewModalComponent } from './components/document-file-preview/document-file-preview-modal/document-file-preview-modal.component';
import { StatusChangeDecisionNotesModalComponent } from './components/status-change-decision-notes-modal/status-change-decision-notes-modal.component';
import { UpsertWorkTimeComponent } from './components/upsert-work-time/upsert-work-time.component';
import { HmsFromSecondsPipe } from './pipes/hms-from-seconds.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TotpSetupModalComponent } from './components/totp-setup-modal/totp-setup-modal.component';

const MODULES = [CommonModule, FormsModule, ReactiveFormsModule, AngularEditorModule, NgApexchartsModule, FontAwesomeModule, FullCalendarModule];

const NG_ZORRO_MODULE_LIST = [
    NzDescriptionsModule,
    NzFormModule,
    NzButtonModule,
    NzIconModule,
    NzSelectModule,
    NzInputModule,
    NzRadioModule,
    NzDatePickerModule,
    NzTimePickerModule,
    NzInputNumberModule,
    NzCheckboxModule,
    IconsProviderModule,
    NzSpinModule,
    NzLayoutModule,
    NzTableModule,
    NzAlertModule,
    NzPageHeaderModule,
    NzMenuModule,
    NzModalModule,
    NzTypographyModule,
    NzToolTipModule,
    NzCollapseModule,
    NzDrawerModule,
    NzUploadModule,
    NzTagModule,
    NzPopoverModule,
    NzDividerModule,
    NzImageModule,
    NzAvatarModule,
    NzDropDownModule,
    NzFlexModule,
    NzTabsModule,
    NzCardModule,
    NzStatisticModule,
    NzSwitchModule,
    NzWaterMarkModule,
    NzBadgeModule,
    NzTimelineModule,
    NzImageModule,
];

const CLARO_COMPONENTS = [
    FilePreviewComponent,
    FilePreviewModalComponent,
    FileViewerComponent,
    DocumentFilePreviewComponent,
    DocumentFilePreviewModalComponent,
    AbsenceCalendarEventInfoModalComponent,
    AbsenceActionsComponent,
    UpsertAbsenceComponent,
    UpsertAccountComponent,
    UpsertAddressComponent,
    UpsertFieldComponent,
    SearchFieldComponent,
    DepartmentSelectComponent,
    UpsertContactComponent,
    UpsertClientComponent,
    ValidationErrorComponent,
    MapComponent,
    PrintoutDialogComponent,
    TrueFalseTableIconComponent,
    FileDownloadLinkComponent,
    WorkTimerComponent,
    ESignComponent,
    ESignFlowSelectComponent,
    ClientNameComponent,
    ClientNotificationConfigModalComponent,
    AddressSelectModalComponent,
    UpsertDocumentComponent,
    DocumentFilesTableComponent,
    DocumentFileSignersModalComponent,
    SearchFieldFormControlComponent,
    HeaderMotdMessagesComponent,
    MotdMessageModalComponent,
    EmployeeNotificationModalComponent,
    RelatedDocumentsListComponent,
    InfoButtonComponent,
    InfoModalComponent,
    ViewSinvoiceComponent,
    UpsertSinvoiceComponent,
    SinvoiceInvoicesTableComponent,
    InvoiceSumFieldsComponent,
    HelpMaterialsModalComponent,
    NotificationHistoryButtonComponent,
    NotificationHistoryModalComponent,
    NotificationHistoryEntryDetailsComponent,
    ViewDocumentComponent,
    StatusChangeDecisionNotesModalComponent,
    UpsertWorkTimeComponent,
    TotpSetupModalComponent,
];

const CLARO_DIRECTIVES = [
    HasPermissionDirective,
    HasAnyPermissionDirective,
    HasDepartmentPermissionDirective,
    HasAnyDepartmentPermissionDirective,
    HasPermissionInAnyDepartmentDirective,
    ValidationErrorDirective,
    DraggableUnitDirective,
];

const CLARO_PIPES = [EurPipe, SafeYoutubePipe, SafeSharepointUrlPipe, SafeHtmlPipe, HmsFromSecondsPipe];

@NgModule({
    imports: [...MODULES, ...NG_ZORRO_MODULE_LIST, ...CLARO_PIPES],

    declarations: [...CLARO_DIRECTIVES, ...CLARO_COMPONENTS],

    exports: [...MODULES, ...NG_ZORRO_MODULE_LIST, ...CLARO_DIRECTIVES, ...CLARO_COMPONENTS, ...CLARO_PIPES],
})
export class SharedModule {}
